import http from "@/utils/http"

/**
 * 积分兑换订单列表
 * @param {object} params
 */
export function pointExchangeOrderPage(params) {
    return http({
        url: "/pointexchange/api/order/page",
        data: params,
        forceLogin: true
    })
}

/**
 * 关闭积分兑换订单
 * @param {object} params
 */
export function closePointExchangeOrder(params) {
    return http({
        url: "/pointexchange/api/order/close",
        data: params,
        forceLogin: true
    })
}
